import { useAuth } from "app/hooks";
import usePageSEO from "app/hooks/usePageSEO";
import { ONE_MINUTE } from "app/types/constants";
import { createEntitySEO } from "app/utils/seo-utils";
import { FC, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useFindByIdQuery } from "store/api/new.api";
import FullScreenLoader from "../loader/FullScreenLoader";
import IdoDetail from "./ido-details";

const IdoDetailWrapper: FC = () => {
  const { idoId } = useParams<{ idoId: string }>();
  const { data: idoData, isLoading } = useFindByIdQuery(idoId, {
    pollingInterval: ONE_MINUTE,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
    refetchOnReconnect: true,
  });
  const isAuth = useAuth();

  // Use the usePageSEO hook with our utility function for cleaner SEO data generation
  const seoData = useMemo(
    () =>
      createEntitySEO(idoData, {
        titlePrefix: "",
        titleSuffix: " IDO | AlphaMind",
        nameField: "name",
        descriptionField: "description",
        imageField: "logoUrl",
        fallbackTitle: "IDO Details | AlphaMind",
        fallbackDescription:
          "Participate in this IDO on AlphaMind. Learn about the project, tokenomics, and how to get involved.",
        isArticle: true,
      }),
    [idoData]
  );

  usePageSEO(seoData);

  if (isLoading) {
    return <FullScreenLoader isLoading={isLoading} />;
  }

  return (
    <>
      {isAuth ? (
        // <NetworkGuard currentStage={idoData.currentStage} supportedNetworks={idoData.supportedNetworks}>
        <IdoDetail />
      ) : (
        // </NetworkGuard>
        <IdoDetail />
      )}
    </>
  );
};

export default IdoDetailWrapper;
